import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';
import { Stripe } from '@awesome-cordova-plugins/stripe/ngx';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
} from '@ionic/angular';
import { GlobalVariable } from '../global';
import { ServerService } from '../providers/server.service';
import { LoginPage } from '../login/login.page';
import { AddReviewsPage } from '../add-reviews/add-reviews.page';
import { BranchIo, } from '@awesome-cordova-plugins/branch-io/ngx';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.page.html',
  styleUrls: ['./payment.page.scss'],
})
export class PaymentPage implements OnInit {
  BirthdayCreditAvailed: any;
  RewardCreditAvailed: any;
  business_array: any = new Array();
  deliver: any;
  StorePoint: any;
  order_date: any;
  instruction: string = '';
  Address: any;
  data: any;
  min: any;
  hours: any;
  future_hours: any;
  future_min: any;
  future_time: any;
  minutes: any;
  response: any;
  deliverFlag: boolean;
  estTime: any;
  storevalue: any;
  reward_amount: number = 0;
  storecreditExist: boolean = false;
  time: any;
  day: number;
  value: string;
  year: number;
  month: any;
  datenow: any;
  date: any;
  ProcessData: any;
  orderId: any;
  orderStatus: any;
  payapalresponse: any;
  cashpay: any = 0;
  ProcessForm: FormGroup;
  paypal: boolean = true;
  creditcard: boolean = false;
  pay_on_venue: boolean = false;
  pickup: boolean = false;
  Schedule_deliver: boolean = false;
  mytime: any;
  myDate: any;
  storeCredit: boolean;
  Deliver: boolean = true;
  deliver_now: boolean = true;
  Tip: number = 0;
  Notes: any;
  orderType: any;
  cash_on_delivery: any;
  gift_falg: boolean = false;
  gift_data: any;
  color: any = 'dark';
  color2: any = 'dark';
  instructions: any = {
    Type: '',
    BusinessDiscount: 0,
    GainDiscount: 0,
    StoreCredit: 0,
    Tip: 0,
    Points: 0,
    Notes: '',
    giftcard: '',
    tax: 0,
    delivery_fee: 0,
  };
  month_array: any[] = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  amount: any=0;
  cardinfo: any = {
    number: '',
    expMonth: '',
    expYear: '',
    cvc: '',
  };
  submitAttempt: boolean = false;
  PaymentForm: FormGroup;
  calculated_tax = 0;
  cash_discount = 0;
  ccFee: number = 0;
  ccFee_added: boolean = true;
  paymentfrom = 'addNew';
  paymentMethods = [];
  subTotal: any;
  // branch io vars
  branchUniversalObj: any;
  shortUrl:any;
  constructor(
    public server: ServerService,
    public modalCtrl: ModalController,
    private nativeStorage: NativeStorage,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public globals: GlobalVariable,

    public formBuilder: FormBuilder,
    public stripe: Stripe,
    public router: Router,
    public route: ActivatedRoute,

    public navCtrl: NavController,
    private branch:BranchIo,
  ) {
    this.PaymentForm = formBuilder.group({
      creditcardno: [
        '',
        Validators.compose([
          Validators.minLength(15),
          Validators.maxLength(16),
          Validators.pattern('[0-9]*'),
          Validators.required,
        ]),
      ],
      expiryMonth: ['', Validators.compose([Validators.required])],
      expiryYear: ['', Validators.compose([Validators.required])],
      CVC: ['', Validators.compose([Validators.required])],
      cardinfo: [false],
    });

    this.calculated_tax = this.router.getCurrentNavigation().extras?.state?.tax;
    this.subTotal = this.router.getCurrentNavigation().extras?.state?.subtotal;
    console.log('subtotal is ', this.subTotal);
   
    this.ccFee = this.router.getCurrentNavigation().extras?.state?.ccFee;
    
    this.cashpay = this.router.getCurrentNavigation().extras?.state?.amount;
    this.storevalue =
      this.router.getCurrentNavigation().extras?.state?.StoreCredit;
    this.estTime = this.globals.estimated_time;
    this.Deliver = this.router.getCurrentNavigation().extras?.state?.deliver;
    this.pickup = this.router.getCurrentNavigation().extras?.state?.pickup;
    this.orderType = this.globals.OrderType;
    this.RewardCreditAvailed =
      this.router.getCurrentNavigation().extras?.state?.RewardAvailed;
    this.BirthdayCreditAvailed =
      this.router.getCurrentNavigation().extras?.state?.BirthdayCreditavailed;
    this.Address = localStorage.getItem('GetAddress');

    if (this.globals.card_enabled) {
      this.color = 'primary';
      this.creditcard = true;
    } else {
      this.cash_on_delivery = true;
    }

    this.Tip = this.router.getCurrentNavigation().extras?.state?.tip;
    this.ProcessForm = this.formBuilder.group({
      Address: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          // Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
        ])
      ),
    });

    // this.ProcessForm :new FormControl( formBuilder.group({
    //     Address: ['', Validators.compose([Validators.required])),
    // });

    this.Notes = this.router.getCurrentNavigation().extras?.state?.notes;
    this.getAddress();

    this.date = new Date();
    this.datenow = this.date.getDate();
    this.month = this.date.getMonth() + 1;
    this.year = this.date.getFullYear();
    this.month = this.month.toString();
    this.day = this.date.getDay();
    this.datenow = this.datenow.toString();
    this.hours = this.date.getHours();
    this.min = this.date.getMinutes();
    if (this.month.length == 1) {
      this.month = '0' + this.month;
    }

    if (this.datenow.length == 1) {
      this.datenow = '0' + this.datenow;
    }

    this.value = this.year + '-' + this.month + '-' + this.datenow;
    this.value.toString();

    if (this.Schedule_deliver == false && this.pickup == true) {
      var date = new Date();
      var date1 = new Date(
        this.date.getTime() - this.date.getTimezoneOffset() * 60000
      ).toISOString();
      this.myDate = date1;
    }

    this.amount = this.router.getCurrentNavigation().extras?.state?.amount;
    this.amount = Number(this.amount);
    //new added 30-june
    if(this.globals.OrderType=='pickup'){
      if(this.subTotal==0){
        globals.card_enabled=true;
        this.amount=0;
        console.log('subtotal is zero');
        // this.ccFee=0;
        // this.amount=0;
  
      }
    }
    //new added 30-june

   
    this.order_date = localStorage.getItem('scheduled_time');
    console.log('scheduled time is', this.order_date);
    //new added to avoid past orders...........
    var checkdate = new Date(
      this.date.getTime() - this.date.getTimezoneOffset() * 60000
    ).toISOString();
    console.log('current time now 1 ', checkdate);
    if (this.order_date <= checkdate) {
      console.log('true................ 1', this.order_date, checkdate);
      this.order_date = checkdate;
      console.log('new time is 1', this.order_date);
    }
    //new added to avoid past orders...........

    // new added on 2/11/2022
    if (
      this.order_date == undefined ||
      this.order_date == 'undefined' ||
      this.order_date == null
    ) {
      this.date = new Date(new Date().setHours(new Date().getHours()));
      var timeis = new Date(this.date).toLocaleString('en-US', {
        hour12: true,
      });
      this.order_date = timeis;
      console.log('set current time as scheduled time ', this.order_date);
    }
    // new added on 2/11/2022

    this.StorePoint =
      this.router.getCurrentNavigation().extras?.state?.StoreAmount;
    this.instruction =
      this.router.getCurrentNavigation().extras?.state?.instruction;
    this.RewardCreditAvailed =
      this.router.getCurrentNavigation().extras?.state?.RewardAvailed;
    this.BirthdayCreditAvailed =
      this.router.getCurrentNavigation().extras?.state?.BirthdayCreditavailed;

    // this.getCreditCard();
    this.getSavedCards();
    this.gift_falg =
      this.router.getCurrentNavigation().extras?.state?.gift_flag;
    this.gift_data = this.router.getCurrentNavigation().extras?.state?.giftcard;
    this.generateShortLink();
    this.process();
    

    if (this.gift_falg) {
      this.payment_on_delivery();
    }
  }

  ngOnInit() {}
  ionViewWillEnter(){
  }
  getSavedCards() {
    let tempArray = [];
    let response = localStorage.getItem('paymentmethods');
    tempArray = JSON.parse(response);
    console.log('from local storage', tempArray);
    if (tempArray != null) {
      this.paymentMethods = tempArray;
    }
  }
  async login_kiosk() {
    let modal = await this.modalCtrl.create({
      component: LoginPage,
    });
    await modal.present();
  }

  ionViewDidLoad() {}

  async paymentThroughPayOnVenue() {
    this.setTime();
    // new added on 2/11/2022
    let loading = await this.loadingCtrl.create({
      message: 'Loading...',
    });
    loading.present();

    let response = this.server.PaymentThroughPayOnVenue(
      this.instructions,
      this.cashpay
    );
    response.subscribe(
      async (data) => {
        this.data = data;
        loading.dismiss();
        if (this.data.success) {
          this.orderStatus = this.data.success;
          let alert = await this.alertCtrl.create({
            header: 'Congratulation',
            subHeader: 'Reservation order has been successfully placed.',
            buttons: ['Okay'],
          });
          alert.present();
          this.navCtrl.navigateForward('home');
        } else {
          let alert = await this.alertCtrl.create({
            subHeader: 'Please try again',
            buttons: ['OK'],
          });
          alert.present();
        }
      },
      (error) => {
        loading.dismiss();
      }
    );
  }

  process() {
    this.Instruction();

    // if (this.globals.type == 'reservation' && this.creditcard == true) {
    // }

    // if (this.globals.type == 'reservation' && this.pay_on_venue == true) {
    //     this.paymentThroughPayOnVenue();
    // } else {
    //     if (this.orderType == "delivery") {
    //         this.submitAttempt = true;
    //     } else {

    //         if (this.creditcard == true) {

    //         } else {

    //         }
    //     }
    // }
  }



  async OrderStatus(Address) {
    let loading = await this.loadingCtrl.create({
      message: 'Loading...',
    });
    loading.present();

    let response;
    if (this.globals.type == 'reservation') {
      response = this.server.OrderStatusThroughPaypalReservation(
        this.instructions,
        this.cashpay
      );
    } else {
      response = this.server.OrderStatusThroughPaypal(
        this.Address,
        this.instructions,
        this.myDate,
        this.cashpay
      );
    }

    response.subscribe(
      async (data) => {
        this.data = data;
        loading.dismiss();
        if (this.data.success) {
          this.orderStatus = this.data.success;
          this.orderId = this.data.orderId;
        } else {
          let alert = await this.alertCtrl.create({
            subHeader: 'Please try again',
            buttons: ['OK'],
          });
          alert.present();
        }
      },
      (error) => {}
    );
  }

  Instruction() {
   
    this.instructions.tax = this.calculated_tax;
    if (this.orderType == 'delivery') {
      this.instructions.Type = 'Delivery';
      let deliveryFee = this.globals.deliveryCharges;

      // if (deliveryFee > 0) {
      console.log('delivery feeeeeee', deliveryFee);

      this.instructions.delivery_fee = Number(this.globals.deliveryCharges);
      // }
    }

    if (this.orderType == 'pickup') {
      this.instructions.Type = 'Pickup';
    }

    if (this.globals.BusinessDiscountFlag == true) {
      this.instructions.BusinessDiscount = Number(
        this.globals.BusinessDiscount
      );
    }

    if (this.globals.GainDiscountFlag == true) {
      this.instructions.GainDiscount = Number(this.globals.GainDiscount);
    }

    if (this.Tip > 0) {
      this.instructions.Tip = Number(this.Tip);
    }

    if (this.Notes) {
      this.instructions.Notes = this.Notes;
    }

    if (Number(this.RewardCreditAvailed) > 0) {
      this.instructions.StoreCredit = Number(this.RewardCreditAvailed);
    }

    if (Number(this.BirthdayCreditAvailed) > 0) {
      this.instructions.StoreCredit = Number(this.BirthdayCreditAvailed);
    }

    if (this.globals.points_availed > 0) {
      this.instructions.Points = Number(this.globals.points_availed);
    }

    if (this.gift_data && this.gift_data.length > 0) {
      this.instructions.giftcard = this.gift_data;
    }

    // link
    if(this.shortUrl){
      this.instructions.review_link=this.shortUrl;
    }
    console.log('all inst',this.instructions)
  }
  financial(x) {
    if (x != 0) {
      return Number.parseFloat(x).toFixed(2);
    } else {
      return '0.00';
    }
  }
  RadeemStoreCredit(flag) {
    let response = this.server.LotteryRedeeem(this.StorePoint, flag);
    response.subscribe(
      (data) => {
        var response = data.json();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  payment_type(PaymentData) {
    if (!this.globals.udid) {
      this.globals.udid = this.globals.caos_udid;
    }

    if (this.globals.type == 'reservation') {
      console.log('here in reserve')
      this.pay_reservation(PaymentData);
    } else {
      this.pay(PaymentData);
    }
  }

  cash_discount_confirmation(type, payment_data?) {
    console.log('type.....',type)
    let date = new Date();
    var checkdate = new Date(
      date.getTime() - this.date.getTimezoneOffset() * 60000
    ).toISOString();
    console.log('current time now ', checkdate);
    if (this.order_date <= checkdate) {
      console.log('true................', this.order_date, checkdate);
      this.order_date = checkdate;
      console.log('new time is', this.order_date);
    }
    // if(checkdate<=this.order_date){
    //     console.log('false................',this.order_date, checkdate)
    //     // this.order_date=checkdate;
    // }
    // break;
    if (type == 'cash') {
    console.log('type.....cash selected',)

      this.payment_on_delivery();
    } else {
      this.payment_type(payment_data);
    }
  }

  async pay_reservation(PaymentData: any) {
    var a = btoa(PaymentData.creditcardno);
    if (!this.PaymentForm.valid) {
      this.submitAttempt = true;
    } else {
      if (PaymentData.cardinfo == true) {
        this.nativeStorage
          .setItem('card', {
            cardno: btoa(PaymentData.creditcardno),
            exmonth: btoa(PaymentData.expiryMonth),
            exyear: btoa(PaymentData.expiryYear),
            cvc: btoa(PaymentData.CVC),
            check: btoa(PaymentData.cardinfo),
          })
          .then(
            () => console.log('Stored item!'),
            (error) => console.error('Error storing item', error)
          );
      }

      this.cardinfo = {
        number: PaymentData.creditcardno,
        expMonth: PaymentData.expiryMonth,
        expYear: PaymentData.expiryYear,
        cvc: PaymentData.CVC,
      };

      let loading = await this.loadingCtrl.create({
        message: 'Loading...',
      });
      loading.present();

      if (this.globals.StripId == '') {
        loading.dismiss();

        let alert = await this.alertCtrl.create({
          // title: 'Oops',
          message: 'Payments not available,please try again',
          buttons: ['OK'],
        });
        alert.present();
      } else {
        this.stripe.setPublishableKey(this.globals.StripId);
        this.stripe.createCardToken(this.cardinfo).then((Token) => {
          if (this.globals.GainDiscountFlag == true) {
            this.globals.GainDiscount = 0;
            this.setDiscount();
          }
          var status;
          if (this.globals.admin_stripe == 'true') {
            status = 'Gain';
          } else {
            status = 'Stripe';
          }

          let response = this.server.PaymentThroughStripeReservation(
            this.instructions,
            this.amount,
            Token
          );
          response.subscribe(
            async (data) => {
              this.data = data;
              loading.dismiss();

              if (this.data.success) {
                let alert = await this.alertCtrl.create({
                  header: 'Congratulation',
                  subHeader: this.data.message,
                  buttons: ['OK'],
                });
                alert.present();

                this.setArray();
                if (this.RewardCreditAvailed > 0) {
                  this.RadeemStoreCredit(false);
                }
                if (this.BirthdayCreditAvailed > 0) {
                  this.RadeemStoreCredit(true);
                }
                if (this.globals.points_availed > 0) {
                  this.RedeemUserPoints();
                }

                this.navCtrl.navigateRoot('home');
              } else {
                let alert_error = await this.alertCtrl.create({
                  header: 'Error',
                  subHeader: this.data.message,
                  buttons: ['OK'],
                });

                alert_error.present();
              }
            },
            (error) => {}
          );
        });
      }
    }
  }
  setTime() {
    let date = new Date();
    console.log('checking for time.........s');
    this.order_date = localStorage.getItem('scheduled_time');
    console.log('scheduled time is', this.order_date);
    //new added to avoid past orders...........
    var checkdate = new Date(
      date.getTime() - this.date.getTimezoneOffset() * 60000
    ).toISOString();
    console.log('current time now ', checkdate);
    if (this.order_date <= checkdate) {
      console.log('true................', this.order_date, checkdate);
      this.order_date = checkdate;
      console.log('new time is', this.order_date);
    }
    //new added to avoid past orders...........

    // new added on 2/11/2022
    if (
      this.order_date == undefined ||
      this.order_date == 'undefined' ||
      this.order_date == null
    ) {
      this.date = new Date(new Date().setHours(new Date().getHours()));
      var timeis = new Date(this.date).toLocaleString('en-US', {
        hour12: true,
      });
      this.order_date = timeis;
      console.log('set current time as scheduled time ', this.order_date);
    }
    // new added on 2/11/2022
  }

  async pay(PaymentData: any) {
    var a = btoa(PaymentData.creditcardno);
    if (!this.PaymentForm.valid) {
      this.submitAttempt = true;
      this.globals.presentToast(
        ' Some values were not given or were incorrect, please fill them'
      );
    } else {
      this.setTime();

      if (PaymentData.cardinfo == true) {
        this.paymentMethods.push(this.PaymentForm.value);
        console.log('saved methods', this.paymentMethods);
        localStorage.setItem(
          'paymentmethods',
          JSON.stringify(this.paymentMethods)
        );
        // this.nativeStorage.setItem('card',
        //     {
        //         cardno: btoa(PaymentData.creditcardno),
        //         exmonth: btoa(PaymentData.expiryMonth),
        //         exyear: btoa(PaymentData.expiryYear),
        //         cvc: btoa(PaymentData.CVC),
        //         check: btoa(PaymentData.cardinfo)
        //     }).then(() => console.log('Stored item!'),
        //         error => console.error('Error storing item', error)
        //     );
      }

      this.cardinfo = {
        number: PaymentData.creditcardno,
        expMonth: PaymentData.expiryMonth,
        expYear: PaymentData.expiryYear,
        cvc: PaymentData.CVC,
      };

      // let loading = await this.loadingCtrl.create({
      //     message: "Loading...",
      // });
      // loading.present();
      this.globals.Loader();

      if (this.globals.authorize_enabled) {
        if (this.globals.GainDiscountFlag == true) {
          this.globals.GainDiscount = 0;
          this.setDiscount();
        }
        var status;
        status = 'Authorize';

        if (this.globals.OrderType == 'pickup') {
          this.Address = '';
        }

        let response = this.server.PaymentThroughStripe(
          this.subTotal,
          this.Address,
          this.instructions,
          this.amount,
          this.order_date,
          '',
          status,
          this.ccFee,
          this.cardinfo
        );
        response.subscribe(
          (data) => {
            this.data = data;
            this.globals.loading.dismiss();
            if (this.data.success) {
              localStorage.removeItem('scheduled_time');
              this.setArray();
              if (this.RewardCreditAvailed > 0) {
                this.RadeemStoreCredit(false);
              }

              if (this.BirthdayCreditAvailed > 0) {
                this.RadeemStoreCredit(true);
              }

              if (this.globals.points_availed > 0) {
                this.RedeemUserPoints();
              }

              if (
                this.globals.BusinessDiscount > 0 &&
                this.globals.availed_discount_count <
                  this.globals.business_discount_count
              ) {
                this.userBusinessDiscountUpdate();
              }

              this.thankyou();
            } else {
              this.globals.presentToast(this.data.message);
            }
          },
          (error) => {}
        );
      } else {
        if (this.globals.StripId == '') {
          this.globals.loading.dismiss();

          let alert = await this.alertCtrl.create({
            header: 'Oops',
            subHeader: 'Payments not available,please try again',
            buttons: ['OK'],
          });
          alert.present();
        } else {
          this.stripe.setPublishableKey(this.globals.StripId);
          this.stripe
            .createCardToken(this.cardinfo)
            .then((Token) => {
              console.log(Token);
              if (this.globals.GainDiscountFlag == true) {
                this.globals.GainDiscount = 0;
                this.setDiscount();
              }
              var status;
              status = 'Stripe';

              if (this.globals.OrderType == 'pickup') {
                this.Address = '';
              }
              let response = this.server.PaymentThroughStripe(
                this.subTotal,
                this.Address,
                this.instructions,
                this.amount,
                this.order_date,
                Token,
                status,
                this.ccFee
              );
              response.subscribe(
                async (data) => {
                  this.data = data;
                  // loading.dismiss();
                  this.globals.loading.dismiss();

                  if (this.data.success) {
                    localStorage.removeItem('scheduled_time');
                    this.setArray();
                    if (this.RewardCreditAvailed > 0) {
                      this.RadeemStoreCredit(false);
                    }
                    if (this.BirthdayCreditAvailed > 0) {
                      this.RadeemStoreCredit(true);
                    }
                    if (this.globals.points_availed > 0) {
                      this.RedeemUserPoints();
                    }

                    if (
                      this.globals.BusinessDiscount > 0 &&
                      this.globals.availed_discount_count <
                        this.globals.business_discount_count
                    ) {
                      this.userBusinessDiscountUpdate();
                    }

                    this.thankyou();
                  } else {
                    let alert_error = await this.alertCtrl.create({
                      header: 'Error',
                      subHeader: this.data.message,
                      buttons: [
                        {
                          text: 'Okay',
                          handler: (data) => {},
                        },
                      ],
                    });
                    alert_error.present();
                  }
                },
                (error) => {
                  // loading.dismiss();
                }
              );
            })
            .catch(async (data) => {
              console.log(data);
              // loading.dismiss();
              this.globals.loading.dismiss();

              let alert = await this.alertCtrl.create({
                header: 'Oops',
                subHeader: 'Invalid Credentials, please try again',
                buttons: ['OK'],
              });

              alert.present();
            });
        }
      }
    }
  }

  async DeliveryConfirm() {
    let alert = await this.alertCtrl.create({
      header: 'Payment',
      message: 'Do you want to Pay on Delivey?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          },
        },
        {
          text: 'Ok',
          handler: () => {
            this.payment_on_delivery();
          },
        },
      ],
    });
    alert.present();
  }

  creditBox() {
    this.color = 'success';
    this.color2 = 'dark';
    this.creditcard = true;
    this.cash_on_delivery = false;

    if (!this.ccFee_added) {
      this.amount = Number(this.amount) + Number(this.ccFee);
      this.ccFee_added = true;
      this.amount = this.amount.toFixed(2);
    }
  }

  deliveryBox() {
    this.color2 = 'success';
    this.color = 'dark ';
    this.creditcard = false;
    this.cash_on_delivery = true;

    if (this.ccFee_added) {
      if(this.ccFee!=0 && this.amount!=0){
      this.amount = Number(this.amount) - Number(this.ccFee);

      }
      // this.amount = Number(this.amount) - Number(this.ccFee);
      this.ccFee_added = false;
      this.amount = this.amount.toFixed(2);
    }
  }

  async payment_on_delivery() {
    this.setTime();

    // let loading = await this.loadingCtrl.create({
    //     message: "Loading...",
    //     // cssClass:'',
    // });
    // loading.present();
    this.globals.Loader();

    if (!this.globals.udid) {
      this.globals.udid = this.globals.caos_udid;
    }

    if (this.globals.GainDiscountFlag == true) {
      this.globals.GainDiscount = 0;
      this.setDiscount();
    }
    var status = 'cash';

    if (this.globals.OrderType == 'pickup') {
      this.Address = '';
    }

    let response = this.server.PaymentOnDelivery(
      this.subTotal,
      this.Address,
      this.instructions,
      this.amount,
      this.order_date,
      '',
      status
    );
    response.subscribe(
      async (data) => {
        this.data = data;
        this.globals.loading.dismiss();

        if (this.data.success) {
          localStorage.removeItem('scheduled_time');

          this.setArray();
          if (this.RewardCreditAvailed > 0) {
            this.RadeemStoreCredit(false);
          }

          if (this.BirthdayCreditAvailed > 0) {
            this.RadeemStoreCredit(true);
          }

          if (this.globals.points_availed > 0) {
            this.RedeemUserPoints();
          }

          if (
            this.globals.BusinessDiscount > 0 &&
            this.globals.availed_discount_count <
              this.globals.business_discount_count
          ) {
            this.userBusinessDiscountUpdate();
          }

          this.thankyou();
        } else {
          let alert_error = await this.alertCtrl.create({
            header: 'Error',
            subHeader: this.data.message,
            buttons: [
              {
                text: 'Okay',
                handler: (data) => {},
              },
            ],
          });
          alert_error.present();
        }
      },
      (error) => {
        this.globals.loading.dismiss();
        console.log(error);
      }
    );
  }

  userBusinessDiscountUpdate() {
    this.globals.availed_discount_count++;
    let response = this.server.userBusinessAvailedDiscount();
    response.subscribe(
      (data) => {},
      (error) => {
        console.log(error);
      }
    );
  }

  async FirstimeFlag() {
    this.nativeStorage
      .getItem('BusinessFirstimeFlag')
      .then(
        async (data) => {
          this.business_array = data.array;
          if (data.array.indexOf(this.globals.username) == -1) {
            this.business_array.push(this.globals.username);
            this.nativeStorage
              .setItem('BusinessFirstimeFlag', { array: this.business_array })
              .then(async () => {
                let modal = await this.modalCtrl.create({
                  component: AddReviewsPage,
                  componentProps: { place: this.globals.business_username },
                });
                modal.present();
              })
              .catch((err) => {
                console.log('nativesstorage', err);
              });
          }
        },
        (error) => {
          this.business_array.push(this.globals.username);
          this.nativeStorage
            .setItem('BusinessFirstimeFlag', { array: this.business_array })
            .then(async () => {
              let modal = await this.modalCtrl.create({
                component: AddReviewsPage,
                componentProps: { place: this.globals.business_username },
              });
              modal.present();
            })
            .catch((err) => {
              console.log('nativesstorage', err);
            });
        }
      )
      .catch((err) => {
        console.log(err);
      });
  }

  RedeemUserPoints() {
    let res = this.server.RedeemUserPoints().subscribe(
      (data) => {
        if (data.status != 'true') {
          return false;
        } else {
          this.globals.points_availed = 0;
          return true;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  setDiscount() {
    this.nativeStorage
      .setItem('discount', { discountValue: this.globals.GainDiscount })
      .then(
        () => console.log('Stored item!'),
        (error) => console.error('Error storing item', error)
      );
  }

  setArray() {
    this.globals.Product.length = 0;
    this.globals.order_time = 'now';
    this.globals.myDate = undefined;
    localStorage.setItem('scheduled_time', undefined);

    this.nativeStorage.setItem('Product', { array: this.globals.Product }).then(
      () => console.log('Stored item!'),
      (error) => console.error('Error storing item', error)
    );
  }

  Savecreditcard() {
    console.log(this.PaymentForm.value.cardinfo);
    // if()
  }

  thankyou() {
    this.globals.bussinessId = this.globals.new_id;
    this.globals.username = this.globals.business_username;
    // this.viewCtrl.dismiss();
    this.navCtrl.navigateRoot('thank-you');
  }

  getCreditCard() {
    this.nativeStorage
      .getItem('card')
      .then((data) => {
        this.PaymentForm.get('creditcardno').setValue(atob(data.cardno));
        this.PaymentForm.get('expiryMonth').setValue(atob(data.exmonth));
        this.PaymentForm.get('expiryYear').setValue(atob(data.exyear));
        this.PaymentForm.get('CVC').setValue(atob(data.cvc));
        this.PaymentForm.get('cardinfo').setValue(atob(data.check));
      })
      .catch((err) => console.log);
  }

  cancel() {
    // this.viewCtrl.dismiss();
    this.navCtrl.navigateRoot('home');
  }

  getAddress() {
    this.Address = localStorage.getItem('GetAddress');
  }
  async selectMethod(PaymentData) {
    var a = btoa(PaymentData.creditcardno);
    // if (!this.PaymentForm.valid) {
    //     this.submitAttempt = true;
    //     this.globals.presentToast(' Some values were not given or were incorrect, please fill them');
    // } else {
    // if (PaymentData.cardinfo == true) {
    //     this.paymentMethods.push(this.PaymentForm.value)
    //     console.log('saved methods',this.paymentMethods)
    //     localStorage.setItem("paymentmethods",JSON.stringify(this.paymentMethods))
    //     // this.nativeStorage.setItem('card',
    //     //     {
    //     //         cardno: btoa(PaymentData.creditcardno),
    //     //         exmonth: btoa(PaymentData.expiryMonth),
    //     //         exyear: btoa(PaymentData.expiryYear),
    //     //         cvc: btoa(PaymentData.CVC),
    //     //         check: btoa(PaymentData.cardinfo)
    //     //     }).then(() => console.log('Stored item!'),
    //     //         error => console.error('Error storing item', error)
    //     //     );
    // }

    this.cardinfo = {
      number: PaymentData.creditcardno,
      expMonth: PaymentData.expiryMonth,
      expYear: PaymentData.expiryYear,
      cvc: PaymentData.CVC,
    };

    let loading = await this.loadingCtrl.create({
      message: 'Loading...',
    });
    loading.present();

    if (this.globals.authorize_enabled) {
      console.log('Payment autherizeEnabled condition true');
      if (this.globals.GainDiscountFlag == true) {
        this.globals.GainDiscount = 0;
        this.setDiscount();
      }
      var status;
      status = 'Authorize';

      if (this.globals.OrderType == 'pickup') {
        this.Address = '';
      }

      this.setTime();

      // ye api
      let response = this.server.PaymentThroughStripe(
        this.subTotal,
        this.Address,
        this.instructions,
        this.amount,
        this.order_date,
        '',
        status,
        this.ccFee,
        this.cardinfo
      );
      response.subscribe(
        (data) => {
          this.data = data;
          loading.dismiss();
          if (this.data.success) {
            localStorage.removeItem('scheduled_time');
            this.setArray();
            if (this.RewardCreditAvailed > 0) {
              this.RadeemStoreCredit(false);
            }

            if (this.BirthdayCreditAvailed > 0) {
              this.RadeemStoreCredit(true);
            }

            if (this.globals.points_availed > 0) {
              this.RedeemUserPoints();
            }

            if (
              this.globals.BusinessDiscount > 0 &&
              this.globals.availed_discount_count <
                this.globals.business_discount_count
            ) {
              this.userBusinessDiscountUpdate();
            }

            this.thankyou();
          } else {
            this.globals.presentToast(this.data.message);
          }
        },
        (error) => {
          loading.dismiss();
          this.globals.presentToast('Something wnt wrong. try again');
        }
      );
    } else {
      if (this.globals.StripId == '') {
        console.log('No stripe ID', this.globals.StripId);
        loading.dismiss();

        let alert = await this.alertCtrl.create({
          header: 'Oops',
          subHeader: 'Payments not available,please try again',
          buttons: ['OK'],
        });
        alert.present();
      } else {
        this.stripe.setPublishableKey(this.globals.StripId);
        this.stripe
          .createCardToken(this.cardinfo)
          .then((Token) => {
            if (this.globals.GainDiscountFlag == true) {
              this.globals.GainDiscount = 0;
              this.setDiscount();
            }
            var status;
            status = 'Stripe';

            if (this.globals.OrderType == 'pickup') {
              this.Address = '';
            }
            let response = this.server.PaymentThroughStripe(
              this.subTotal,
              this.Address,
              this.instructions,
              this.amount,
              this.order_date,
              Token,
              status,
              this.ccFee
            );
            response.subscribe(
              async (data) => {
                this.data = data;
                loading.dismiss();
                if (this.data.success) {
                  localStorage.removeItem('scheduled_time');
                  this.setArray();
                  if (this.RewardCreditAvailed > 0) {
                    this.RadeemStoreCredit(false);
                  }
                  if (this.BirthdayCreditAvailed > 0) {
                    this.RadeemStoreCredit(true);
                  }
                  if (this.globals.points_availed > 0) {
                    this.RedeemUserPoints();
                  }

                  if (
                    this.globals.BusinessDiscount > 0 &&
                    this.globals.availed_discount_count <
                      this.globals.business_discount_count
                  ) {
                    this.userBusinessDiscountUpdate();
                  }

                  this.thankyou();
                } else {
                  let alert_error = await this.alertCtrl.create({
                    header: 'Error',
                    subHeader: this.data.message,
                    buttons: [
                      {
                        text: 'Okay',
                        handler: (data) => {},
                      },
                    ],
                  });
                  alert_error.present();
                }
              },
              (error) => {
                // loading.dismiss();
              }
            );
          })
          .catch(async (data) => {
            console.log('stripe failed', data);
            loading.dismiss();
            let alert = await this.alertCtrl.create({
              header: 'Oops',
              subHeader: 'Invalid Credentials, please try again',
              buttons: ['OK'],
            });

            alert.present();
          });
      }
    }

    // }
  }


  generateShortLink(){
       let properties = {
        canonicalIdentifier: '',
        canonicalUrl: 'https://thehalalguide.com',
        contentMetadata: {
          business: this.globals.activeCartBusinessData,
          order:this.globals.Product,
          udid:this.globals.udid
        }
      }
      this.branch.createBranchUniversalObject(properties).then((res) => {  //create universal object
        this.branchUniversalObj = res
        console.log('createing object for url Response: ' + JSON.stringify(res))
        this.generateLINK();
      }).catch((err) => {
        console.log('Error: ' + JSON.stringify(err))
      });
    
   
  }
  generateLINK() {
    var analytics = {}
    var properties = {
      // $desktop_url: 'https://play.google.com/store/apps/details?id=net.thehalalguide.app',
      // $android_url: 'https://play.google.com/store/apps/details?id=net.thehalalguide.app',
      businessPage: true,
      // business:{
      //   address:this.globals.activeCartBusinessData.address,
      //   id:this.globals.activeCartBusinessData.business_id,
      // }

    }
    this.branchUniversalObj.generateShortUrl(analytics, properties).then((res) => {
      console.log(res)
      // console.log('url genrate Response: ' + JSON.stringify(res.url))
      this.shortUrl = res.url;
      console.log('short url', this.shortUrl);
      // setting instructions after generating link.
      this.process();
      
    }).catch((err) => {
      console.log('Error: ' + JSON.stringify(err))
    })
  }
}
